import { Loader } from 'google-maps';

export default (
	mapsApiKey,
	id,
	partners = [],
) => ({
	map: null,
	infoWindow: null,
	markers: [],
	searchPhrase: "",
	filteredPartners: [],

	init() {
		const loader = new Loader(mapsApiKey);
		loader.load().then((google) => {
			const budapest = { lat: 47.4979, lng: 19.0402 };
			this.initMap(google, budapest);
			this.filterPartners();
		});
	},

	initMap(google, center) {
		this.map = new google.maps.Map(
			document.getElementById(id),
			{
				zoom: 11,
				center,
			}
		);

		this.infoWindow = new google.maps.InfoWindow();
	},

	refreshMarkers() {
		for (let i = 0; i < this.markers.length; i++) {
			this.markers[i].setMap(null);
			this.markers[i] = null;
		}
		this.markers = this.filteredPartners.map((partner) => {
				let marker = new google.maps.Marker({
					position: partner.position,
					title: partner.partner,
					map: this.map,
					clickable: true,
					icon: './assets/images/map_marker.png',
				});
				marker.addListener('click', () => {
					this.setInfoWindow(partner);
					this.infoWindow.open(this.map, marker);
				});

				return marker;
			}
		);

		if (this.markers.length > 0) {
			const bounds = new google.maps.LatLngBounds();
			for (var i = 0; i < this.markers.length; i++) {
				bounds.extend(this.markers[i].getPosition());
			}
			this.map.setCenter(bounds.getCenter());
			if (this.markers.length > 1) {
				this.map.fitBounds(bounds);
			} else {
				this.map.setZoom(11);
			}
		}
	},

	zoomToMarker(event, index, partner) {
		if (event.button === 0) {
			event.preventDefault();
			if (index >= 0 && index < this.markers.length) {
				document.getElementById('map').scrollIntoView();
				this.map.setCenter(this.markers[index].getPosition());
				this.map.setZoom(15);
				this.setInfoWindow(partner);
				this.infoWindow.open(this.map, this.markers[index]);
			}
		}
	},

	setInfoWindow(partner) {
		this.infoWindow.setContent(`
				<div class="map-info-window">
					<h3>${partner.partner}</h3>
					<p>${partner.postalcode} ${partner.city}${partner.district && partner.district != partner.postalcode ? ' ' + partner.district : ''}</p>
					<p>${partner.street}</p>
				</div>
			`);
	},

	filterPartners() {
		if (this.searchPhrase.length < 3) {
			this.filteredPartners = [];
		} else {
			const s = this.searchPhrase.toLowerCase()
			this.filteredPartners = partners.filter(p => {
				return p.city.toLowerCase() == s||
					p.postalcode == s;
			}).sort((a, b) => a.weight - b.weight);
		}
		this.refreshMarkers();
	},

	gtm(data) {
		window.dataLayer = window.dataLayer || [];
		let numericRegex = /^\d+$/;

		if(!numericRegex.test(data.filterType)){
			data.filterType = `search_${data.filterType}`;
		}

		window.dataLayer.push(data);
	},
});
